<ion-col size="4">
  <ion-title class="ion-text-start">FAQs</ion-title>
  <ion-card >
    <ion-card-content>
      <p class="question">What is the customer care number?</p>
      <p class="answer">98989898989</p>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-content>
      <p class="question">Lorem Ipsum has been the industry's standard?</p>
    <p class="answer">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-content>
    <p class="question">Lorem Ipsum has been the industry's standard?</p>
    <p class="answer">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-content>
    <p class="question">Lorem Ipsum has been the industry's standard?</p>
    <p class="answer">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
    </ion-card-content>
  </ion-card>
</ion-col>